export const TOGGLE_IS_OPEN = 'TOGGLE_IS_OPEN';

export const HIDE_MENU = 'HIDE_MENU';

export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';

export const MARK_NOTIFICATIONS_READ = 'MARK_NOTIFICATIONS_READ';

export const TOGGLE_NOTIFICATION = 'READ_NOTIFICATIONS';
